import styled from 'styled-components';

import { minWidth } from '@calm-web/design-system';

export const Wrapper = styled.div`
	margin-top: 28px;

	${minWidth('tablet')} {
		margin-top: 0;
	}
`;
